import React, { Component } from 'react';
import './App.css';
import { BrowserRouter} from 'react-router-dom';
import { Layout} from 'antd';
import LeftSide from './layouts/LeftSide'
import Headers from './layouts/Headers'
import RightSide from './layouts/RightSide'
import './App.css';
import './layouts/Header.css';
import Login from './layouts/Login'
import { connect } from 'react-redux';
import intl from 'react-intl-universal';
const SUPPOER_LOCALES = [
  {
    name: "English",
    value: "en-US"
  },
  {
    name: "简体中文",
    value: "zh-CN"
  }
];

class App extends Component {
  componentDidMount(){
    this.props.updateWidthAndHeight(document.body.scrollWidth,document.body.scrollHeight,document.body.clientHeight,document.body.clientWidth)
    window.addEventListener('resize',()=>{
      this.props.updateWidthAndHeight(document.body.scrollWidth,document.body.scrollHeight,document.body.clientHeight,document.body.clientWidth)
    })
  }

  constructor(){
    super()
    let currentLocale = sessionStorage.getItem("language")
    if(currentLocale === null || currentLocale === undefined){
      currentLocale = SUPPOER_LOCALES[0].value
    }
    intl.init({
      currentLocale,
      locales:{
        [currentLocale]: require(`./locales/${currentLocale}`)
      }
    });
    sessionStorage.setItem("language", currentLocale);
  }

  logoutCallBack = () => {
    sessionStorage.clear();
    window.location.href="/";
  }


  loginCallBack = (userName) => {
    sessionStorage.setItem('isLoggedIn', true);
    window.location.href="/";
  }
  render() {
    if(sessionStorage.getItem('isLoggedIn')){
      return (
        <div>
          <BrowserRouter>
            <Layout style={{ minHeight: '100vh'}}>
              <LeftSide snAdultValue={this.props.adultControlValue}></LeftSide>
              <Layout style={{height: this.props.scrollWidth * 0.5, overflowY: 'auto'}}>
                <Headers language={SUPPOER_LOCALES} logoutCallBack={this.logoutCallBack}>
                </Headers>
                <RightSide></RightSide>
              </Layout>
            </Layout>
          </BrowserRouter>
      </div>
      );
    }else{
      return(
        <div>
            <BrowserRouter>
              <Login loginCallBack={this.loginCallBack}/>
            </BrowserRouter>
        </div>
      );
    }
  }
}
const mapState = (state) => {
  return {
    scrollWidth : state.clientLink.scrollWidth,
    adultControlValue : state.clientLink.adultControlValue,
  }
}

const mapDispatch = (dispatch) => {
  return {
    updateWidthAndHeight(width,height,clientHeight,clientWidth){
      return dispatch({
        type:'updateWidthAndHeight',
        data:{
          width:width,
          height:height,
          clientHeight:clientHeight,
          clientWidth : clientWidth
        }
      })
    },
    
  }
}

export default connect(mapState, mapDispatch)(App);


// WEBPACK FOOTER //
// ./src/App.js